export type TokenConsumerState = Record<string, { tokensForUser: number; budgetForUser: number }>;

export const initialState: TokenConsumerState = {};
